module.exports = __webpack_public_path__ + "img/jt_red@2x.d901cc2e.png";